import { Box, Button, ButtonProps, CircularProgress, SxProps } from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";

export default forwardRef((_props: ButtonProps & { loading?: boolean; wrapperSx?: SxProps }, ref: any) => {
  const {
    className,
    wrapperSx,
    loading: loadingProps = false,
    onClick,
    variant = "contained",
    disabled,
    children,
    ...restProps
  } = _props;
  const [loading, setLoading] = useState(loadingProps);

  useImperativeHandle(ref, () => ({
    onClick() {
      handleButtonClick({} as any);
    },
  }));

  const handleButtonClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClick) {
      return;
    }
    try {
      setLoading(true);
      await onClick(e);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={className} sx={{ position: "relative", display: "inline-block", ...wrapperSx }}>
      <Button
        {...restProps}
        variant={variant}
        className={`initial-text ${className || ""}`}
        disabled={disabled || loading}
        onClick={handleButtonClick}
      >
        {children}
      </Button>

      {loading && (
        <CircularProgress
          size={24}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      )}
    </Box>
  );
});
